module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zk-row",
    class: [_vm.justify !== 'start' ? 'is-justify-' + _vm.justify : '', _vm.align !== 'top' ? 'is-align-' + _vm.align : '', {
      'zk-row--flex': _vm.type === 'flex'
    }],
    style: (_vm.style)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-703ac802"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/row/src/row.vue
// module id = 267
// module chunks = 0